import { compose, isNil, not, path, prop } from 'ramda'
import { createSelector } from 'reselect'

import { displayName } from 'shared/lib/user'

const USER_PATH = ['user']

// redux (current) user selectors
export const currentUserSelector = path(USER_PATH)

export const currentUserIdSelector = createSelector(
  currentUserSelector,
  prop(':db/id')
)

export const currentUserUuidSelector = createSelector(
  currentUserSelector,
  prop(':user/squuid')
)

export const userPathSelector = createSelector(
  currentUserUuidSelector,
  userUuid => `/user/${userUuid}`
)

export const hasCurrentUserSelector = createSelector(
  currentUserSelector,
  compose(not, isNil)
)

export const hasPasswordSelector = createSelector(
  currentUserSelector,
  prop('@user/has-password')
)

export const displayNameSelector = createSelector(
  currentUserSelector,
  displayName
)

export const userAdminCapsSelector = createSelector(
  currentUserSelector,
  prop(':user/admin-caps')
)
